(function () {
  if (window.__advancedDescriptionReady) return;
  window.__advancedDescriptionReady = true;

  function initVideo(root) {
    var video = root.querySelector('.pdpv__video');
    var wrap = root.querySelector('[data-pdpv-wrap]');
    var btn = root.querySelector('[data-pdpv-toggle]');
    if (!video || !wrap || !btn) return;

    try { video.controls = false; } catch (e) {}

    function setState(playing) {
      wrap.classList.toggle('is-playing', !!playing);
      var S = (window.gwaStrings && window.gwaStrings.advanced_description) || {};
      btn.setAttribute('aria-label', playing ? (S.stop_video || 'Stop video') : (S.play_video || 'Play video'));
    }

    function stop() {
      try { video.pause(); } catch (e) {}
      try { video.currentTime = 0; } catch (e) {}
      setState(false);
    }

    function play() {
      try {
        if (video.dataset.src && !video.hasAttribute('src')) video.src = video.dataset.src;
        video.querySelectorAll('source[data-src]').forEach(function (source) {
          if (!source.hasAttribute('src')) source.src = source.dataset.src;
        });
        if (!video.dataset.sourcesLoaded) {
          video.dataset.sourcesLoaded = 'true';
          video.load();
        }
        var promise = video.play();
        if (promise && typeof promise.then === 'function') {
          promise.then(function () {
            setState(true);
          }).catch(function () {
            setState(false);
          });
        } else {
          setState(true);
        }
      } catch (e) {
        setState(false);
      }
    }

    function toggleVideo(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (video.paused) play();
      else stop();
    }

    wrap.addEventListener('click', toggleVideo, true);
    btn.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        toggleVideo(event);
      }
    });

    video.addEventListener('ended', stop);
    video.addEventListener('pause', function () {
      if (video.currentTime === 0 || video.ended) setState(false);
    });
  }

  function initReadMore(root) {
    var wrap = root.querySelector('[data-pdpv-content-wrap]');
    var btn = root.querySelector('[data-pdpv-readmore]');
    if (!wrap) return;

    if (root.getAttribute('data-has-video') === 'false' || root.classList.contains('pdpv--no-video')) {
      wrap.classList.remove('is-clamped', 'is-expanded');
      if (btn) btn.hidden = true;
      return;
    }

    if (!btn) return;

    var clampHeight = 16 * parseFloat(getComputedStyle(document.documentElement).fontSize);

    function check() {
      wrap.classList.remove('is-clamped', 'is-expanded');
      btn.hidden = true;
      if (wrap.scrollHeight > clampHeight + 40) {
        wrap.classList.add('is-clamped');
        btn.hidden = false;
      }
    }

    btn.addEventListener('click', function () {
      var expanded = wrap.classList.contains('is-expanded');
      if (expanded) {
        wrap.classList.remove('is-expanded');
        wrap.classList.add('is-clamped');
        btn.querySelector('[data-pdpv-more]').hidden = false;
        btn.querySelector('[data-pdpv-less]').hidden = true;
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        wrap.classList.remove('is-clamped');
        wrap.classList.add('is-expanded');
        btn.querySelector('[data-pdpv-more]').hidden = true;
        btn.querySelector('[data-pdpv-less]').hidden = false;
      }
    });

    setTimeout(check, 0);
    window.addEventListener('resize', check, { passive: true });
  }

  function init(root) {
    if (!root || root.dataset.advancedDescriptionInitialized === 'true') return;

    var sourceEl = root.querySelector('[data-pdpv-source]');
    var titleEl = root.querySelector('[data-pdpv-title]');
    var contentEl = root.querySelector('[data-pdpv-content]');
    if (!sourceEl || !titleEl || !contentEl) return;

    root.dataset.advancedDescriptionInitialized = 'true';

    var raw = sourceEl.innerHTML || '';
    if (!raw.trim()) return;

    var doc = new DOMParser().parseFromString(raw, 'text/html');
    var nodes = Array.from(doc.body.children);
    var isH1 = function (el) { return el && el.tagName === 'H1'; };
    var isH2 = function (el) { return el && el.tagName === 'H2'; };
    var firstH1 = nodes.findIndex(isH1);
    var firstH2 = nodes.findIndex(isH2);
    var titleIndex = -1;

    if (firstH1 !== -1) {
      titleIndex = firstH1;
      titleEl.textContent = (nodes[firstH1].textContent || '').trim();
    } else if (firstH2 !== -1) {
      titleIndex = firstH2;
      titleEl.textContent = (nodes[firstH2].textContent || '').trim();
    } else {
      return;
    }

    var startIdx = titleIndex + 1;
    var cutIdx = -1;
    for (var i = startIdx; i < nodes.length; i += 1) {
      if (isH2(nodes[i])) {
        cutIdx = i;
        break;
      }
    }
    var endIdx = cutIdx === -1 ? nodes.length : cutIdx;

    var frag = document.createDocumentFragment();
    for (var j = startIdx; j < endIdx; j += 1) {
      var el = nodes[j];
      if (!el) continue;
      var text = (el.textContent || '').replace(/\u00A0/g, ' ').trim();
      var hasMedia = !!el.querySelector && !!el.querySelector('img,video,iframe,svg,source,picture');
      if (!text && !hasMedia) continue;
      frag.appendChild(el.cloneNode(true));
    }

    var tmp = document.createElement('div');
    tmp.appendChild(frag);
    var htmlOut = (tmp.innerHTML || '').trim();
    if (!htmlOut) return;

    contentEl.innerHTML = htmlOut;
    root.removeAttribute('hidden');

    initVideo(root);
    initReadMore(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pdpv-root]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
